import { Box, Container, IconButton, Typography, Grid, LinearProgress, Select, MenuItem, FormControl } from '@mui/material'
import React, { useState, useEffect } from 'react'
import {
    ArrowBack as ArrowBackIcon,
    SelfImprovement as YogaIcon,
    CalendarMonth as AppointmentIcon,
    DirectionsRun as ActivityIcon,
    Chat as ChatIcon,
    Mood as MoodIcon,
    TrendingUp as TrendingUpIcon,
    AccessTime as TimeIcon,
    MenuBook as GratitudeIcon,
    MusicNote as MusicIcon,
    GraphicEq as SoundTherapyIcon,
    Assignment as AssessmentIcon,
    Podcasts as PodcastIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getUserEventCount } from '../../service/insights';

const Insights = () => {
    const navigate = useNavigate();
    const userId = localStorage.getItem("user_id");
    const _institution = localStorage.getItem('institution') || '';
    const isRvce = _institution.toLowerCase().includes('rvce');
    const [timeFilter, setTimeFilter] = useState('weekly');
    const [eventCount, setEventCount] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [insights, setInsights] = useState({
        yogaVideos: { count: 0, trend: 0, goal: 10 },
        appointments: { count: 0, upcoming: 0 },
        activities: { count: 0, trend: 0, goal: 20 },
        counselorChats: { count: 0, avgDuration: 0 },
        moodCheckins: { count: 0, avgMood: 0 },
        timeSpent: { hours: 0, minutes: 0, totalMinutes: 0 },
        gratitudeJournal: { count: 0, streak: 0 },
        careMusic: { count: 0, totalMinutes: 0 },
        soundTherapy: { count: 0, avgDuration: 0 },
        assessments: { count: 0, completed: 0 },
        podcasts: { count: 0, totalMinutes: 0 },
        care: { count: 0 },

    });

    // useEffect(() => {
    //     const fetchInsights = async () => {
    //         const user = JSON.parse(localStorage.getItem('user') || '{}');
    //         if (user.id) {
    //             try {
    //                 setIsLoading(true);
    //                 const today = new Date();
    //                 const fromDate = new Date(today.setDate(today.getDate() - 7));
    //                 const toDate = new Date();

    //                 const response = await getUserEventCount(
    //                     user.id,
    //                     fromDate.toISOString().split('T')[0],
    //                     toDate.toISOString().split('T')[0]
    //                 );
    //                 setEventCount(response);

    //                 // Map API response to insights state
    //                 setInsights({
    //                     yogaVideos: {
    //                         count: response.event_counts?.['yoga'] || 0,
    //                         trend: 0,
    //                         goal: 10
    //                     },
    //                     appointments: {
    //                         count: response.event_counts?.['appointment-created'] || 0,
    //                         upcoming: 0
    //                     },
    //                     activities: {
    //                         count: response.event_counts?.['Quick action'] || 0,
    //                         trend: 0,
    //                         goal: 20
    //                     },
    //                     counselorChats: {
    //                         count: response.event_counts?.['converse'] || 0,
    //                         avgDuration: 0
    //                     },
    //                     moodCheckins: {
    //                         count: response.event_counts?.['mood_checkin'] || 0,
    //                         avgMood: 7
    //                     },
    //                     gratitudeJournal: {
    //                         count: response.event_counts?.['gratitude_journal'] || 0,
    //                         streak: 0
    //                     },
    //                     careMusic: {
    //                         count: response.event_counts?.['care'] || 0,
    //                         totalMinutes: 0
    //                     },
    //                     soundTherapy: {
    //                         count: response.event_counts?.['sound_therapy'] || 0,
    //                         avgDuration: 0
    //                     },
    //                     assessments: {
    //                         count: response.event_counts?.['wellness_assessment'] || 0,
    //                         completed: 0
    //                     },
    //                     podcasts: {
    //                         count: response.event_counts?.['podcast'] || 0,
    //                         totalMinutes: 0
    //                     },
    //                     care: { count: response.event_counts?.['care'] || 0 },
    //                     consult: { count: response.event_counts?.['consult'] || 0 },
    //                     login: { count: response.event_counts?.['login'] || 0 },
    //                     pageView: { count: response.event_counts?.['page_view'] || 0 },
    //                     timeSpent: {
    //                         hours: Math.floor((response.usage_seconds?.daily || 0) / 3600),
    //                         minutes: Math.floor(((response.usage_seconds?.daily || 0) % 3600) / 60),
    //                         totalMinutes: response.usage_seconds?.daily || 0
    //                     }
    //                 });
    //                 setIsLoading(false);
    //             } catch (error) {
    //                 console.error('Error fetching insights:', error);
    //                 setIsLoading(false);
    //             }
    //         }
    //     };

    //     fetchInsights();
    // }, []);

    useEffect(() => {
        const fetchInsights = async () => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            if (!user.id) return;

            try {
                setIsLoading(true);

                const today = new Date();
                let fromDate = new Date();

                // 🔥 Handle filter logic
                if (timeFilter === "daily") {
                    fromDate.setDate(today.getDate() - 1);
                } else if (timeFilter === "weekly") {
                    fromDate.setDate(today.getDate() - 7);
                } else if (timeFilter === "monthly") {
                    fromDate.setMonth(today.getMonth() - 1);
                }

                const toDate = new Date();

                const response = await getUserEventCount(
                    user.id,
                    fromDate.toISOString().split('T')[0],
                    toDate.toISOString().split('T')[0]
                );

                setEventCount(response);

                // 🔥 Map API response
                setInsights({
                    yogaVideos: {
                        count: response.event_counts?.['yoga'] || 0,
                        trend: 0,
                        goal: 10
                    },
                    appointments: {
                        count: response.event_counts?.['appointment-created'] || 0,
                        upcoming: 0
                    },
                    activities: {
                        count: (response.event_counts?.['breathe'] || 0) + 
                               (response.event_counts?.['stretch'] || 0) + 
                               (response.event_counts?.['gratitude'] || 0) + 
                               (response.event_counts?.['smile'] || 0),
                        trend: 0,
                        goal: 20
                    },
                    counselorChats: {
                        count: response.event_counts?.['converse'] || 0,
                        avgDuration: 0
                    },
                    moodCheckins: {
                        count: response.event_counts?.['mood_checkin'] || 0,
                        avgMood: 7
                    },
                    gratitudeJournal: {
                        count: response.event_counts?.['gratitude_journal'] || 0,
                        streak: 0
                    },
                    careMusic: {
                        count: response.event_counts?.['care'] || 0,
                        totalMinutes: 0
                    },
                    soundTherapy: {
                        count: response.event_counts?.['sound_therapy'] || 0,
                        avgDuration: 0
                    },
                    assessments: {
                        count: response.event_counts?.['wellness_assessment'] || 0,
                        completed: 0
                    },
                    podcasts: {
                        count: response.event_counts?.['podcast'] || 0,
                        totalMinutes: 0
                    },
                    care: { count: response.event_counts?.['care'] || 0 },
                    consult: { count: response.event_counts?.['consult'] || 0 },
                    login: { count: response.event_counts?.['login'] || 0 },
                    pageView: { count: response.event_counts?.['page_view'] || 0 },
                    timeSpent: {
                        hours: Math.floor((response.usage_seconds?.daily || 0) / 3600),
                        minutes: Math.floor(((response.usage_seconds?.daily || 0) % 3600) / 60),
                        totalMinutes: response.usage_seconds?.daily || 0
                    }
                });

            } catch (error) {
                console.error('Error fetching insights:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchInsights();
    }, [timeFilter]); // 👈 VERY IMPORTANT

    // const yogaCount = eventCount?.event_counts?.yoga ?? 0;

    // dynamically pick usage based on filter
    const usageSeconds =
        eventCount?.usage_seconds?.[timeFilter] ?? 0;

    const usageHours = Math.floor(usageSeconds / 3600);
    const usageMinutes = Math.floor((usageSeconds % 3600) / 60);


    const formatDate = (date) => {
        return date.toISOString().split("T")[0]; // YYYY-MM-DD
    };


    const insightCards = [
        // {
        //     title: 'Yoga Videos',
        //     icon: <YogaIcon sx={{ fontSize: 32 }} />,
        //     count: insights.yogaVideos.count,
        //     subtitle: `${insights.yogaVideos.trend}% increase this week`,
        //     color: '#7C3AED',
        //     bgColor: '#F5F3FF',
        //     progress: (insights.yogaVideos.count / insights.yogaVideos.goal) * 100,
        //     progressLabel: `${insights.yogaVideos.count}/${insights.yogaVideos.goal} weekly goal`
        // },
        {
            title: 'Yoga Videos',
            icon: <YogaIcon sx={{ fontSize: 32 }} />,
            count: insights.yogaVideos.count,
            subtitle: 'Total videos watched',
            color: '#7C3AED',
            bgColor: '#F5F3FF',
            progress: (insights.yogaVideos.count / insights.yogaVideos.goal) * 100,
            progressLabel: `${insights.yogaVideos.count}/${insights.yogaVideos.goal} weekly goal`
        },

        {
            title: 'Appointments',
            icon: <AppointmentIcon sx={{ fontSize: 32 }} />,
            count: insights.appointments.count,
            subtitle: `${insights.appointments.upcoming} upcoming`,
            color: '#0891B2',
            bgColor: '#ECFEFF',
            info: 'Total completed',
            rvceDisabled: true
        },
        {
            title: 'Activities Done',
            icon: <ActivityIcon sx={{ fontSize: 32 }} />,
            count: insights.activities.count,
            subtitle: `${insights.activities.trend}% more than last week`,
            color: '#059669',
            bgColor: '#ECFDF5',
            progress: (insights.activities.count / insights.activities.goal) * 100,
            progressLabel: `${insights.activities.count}/${insights.activities.goal} monthly goal`
        },
        {
            title: 'Converse',
            icon: <ChatIcon sx={{ fontSize: 32 }} />,
            count: insights.counselorChats.count,
            subtitle: `Avg. ${insights.counselorChats.avgDuration} min per session`,
            color: '#DC2626',
            bgColor: '#FEF2F2',
            info: 'Total sessions',
            rvceDisabled: true
        },
        {
            title: 'Mood Check-ins',
            icon: <MoodIcon sx={{ fontSize: 32 }} />,
            count: insights.moodCheckins.count,
            subtitle: `Average mood: ${insights.moodCheckins.avgMood}/10`,
            color: '#F59E0B',
            bgColor: '#FFFBEB',
            info: 'This month'
        },
        // {
        //     title: 'Time Spent on App',
        //     icon: <TimeIcon sx={{ fontSize: 32 }} />,
        //     count: `${insights.timeSpent.hours}h ${insights.timeSpent.minutes}m`,
        //     subtitle: 'This week',
        //     color: '#6366F1',
        //     bgColor: '#EEF2FF',
        //     info: 'Active time',
        //     customCount: true
        // },
        {
            title: 'Time Spent on App',
            icon: <TimeIcon sx={{ fontSize: 32 }} />,
            count: `${usageHours}h ${usageMinutes}m`,
            subtitle: 'This week',
            color: '#6366F1',
            bgColor: '#EEF2FF',
            info: 'Active time',
            customCount: true
        },

        {
            title: 'Gratitude Journal',
            icon: <GratitudeIcon sx={{ fontSize: 32 }} />,
            count: insights.gratitudeJournal.count,
            subtitle: `${insights.gratitudeJournal.streak} day streak`,
            color: '#EC4899',
            bgColor: '#FCE7F3',
            info: 'Entries'
        },
        {
            title: 'Care Music',
            icon: <MusicIcon sx={{ fontSize: 32 }} />,
            count: insights.careMusic.count,
            subtitle: `${insights.careMusic.totalMinutes} min total`,
            color: '#8B5CF6',
            bgColor: '#F3E8FF',
            info: 'Tracks played',
            rvceDisabled: true
        },
        {
            title: 'Sound Therapy',
            icon: <SoundTherapyIcon sx={{ fontSize: 32 }} />,
            count: insights.soundTherapy.count,
            subtitle: `Avg. ${insights.soundTherapy.avgDuration} min per session`,
            color: '#14B8A6',
            bgColor: '#CCFBF1',
            info: 'Sessions'
        },
        {
            title: 'Assessments',
            icon: <AssessmentIcon sx={{ fontSize: 32 }} />,
            count: insights.assessments.count,
            subtitle: `${insights.assessments.completed} completed`,
            color: '#F97316',
            bgColor: '#FFEDD5',
            info: 'Total taken'
        },
        {
            title: 'Podcasts',
            icon: <PodcastIcon sx={{ fontSize: 32 }} />,
            count: insights.podcasts.count,
            subtitle: `${insights.podcasts.totalMinutes} min listened`,
            color: '#0EA5E9',
            bgColor: '#E0F2FE',
            info: 'Episodes'
        }
    ];
    if (isLoading) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h6">Loading insights...</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)' }}>
            <Container maxWidth="lg" sx={{ py: 4 }}>
                {/* Header */}
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, justifyContent: "space-between" }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0B2D6B', background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                            Insights
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <FormControl size="small">
                                <Select
                                    value={timeFilter}
                                    onChange={(e) => setTimeFilter(e.target.value)}
                                    sx={{
                                        backgroundColor: '#F0F5FF',
                                        borderRadius: 2,
                                        fontSize: '0.875rem',
                                        fontWeight: 600,
                                        color: '#0B2D6B',
                                        minWidth: 120,
                                        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                        '&:hover': { backgroundColor: '#E0EBFF' },
                                        '& .MuiSelect-select': { py: 1, px: 2 }
                                    }}
                                >
                                    <MenuItem value="daily">Daily</MenuItem>
                                    <MenuItem value="weekly">Weekly</MenuItem>
                                    <MenuItem value="monthly">Monthly</MenuItem>
                                </Select>
                            </FormControl>

                            <IconButton
                                onClick={() => navigate(-1)}
                                sx={{
                                    backgroundColor: '#F0F5FF',
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    color: '#0B2D6B',
                                    '&:hover': {
                                        backgroundColor: '#E0EBFF'
                                    }
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </Box>

                {/* Insights Grid */}
                <Grid container spacing={2}>
                    {insightCards.map((card, index) => {
                        const isDisabled = isRvce && card.rvceDisabled;
                        return (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box
                                sx={{
                                    p: 2.5,
                                    borderRadius: 3,
                                    backdropFilter: 'blur(8px)',
                                    background: isDisabled
                                        ? '#f5f5f5'
                                        : 'linear-gradient(135deg, #f9f9f912 0%, #f9f9f905 100%)',
                                    border: isDisabled ? '2px solid #e8e8e8' : '2px solid #e0e0e0',
                                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                                    transition: 'all 0.3s ease-in-out',
                                    height: '100%',
                                    opacity: isDisabled ? 0.5 : 1,
                                    position: 'relative',
                                    ...(!isDisabled && {
                                        '&:hover': {
                                            border: '2px solid #bdbdbd',
                                            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                                            transform: 'translateY(-2px)'
                                        }
                                    })
                                }}
                            >
                                {isDisabled && (
                                    <Box sx={{
                                        position: 'absolute', top: 8, right: 8,
                                        bgcolor: '#e5e7eb', color: '#9ca3af',
                                        fontSize: '0.65rem', fontWeight: 600,
                                        px: 1, py: 0.3, borderRadius: 1,
                                        letterSpacing: 0.5, textTransform: 'uppercase'
                                    }}>
                                        Not Available
                                    </Box>
                                )}
                                {/* Icon and Badge */}
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'space-between',
                                    mb: 2
                                }}>
                                    <Box
                                        sx={{
                                            width: 56,
                                            height: 56,
                                            borderRadius: 2,
                                            backgroundColor: card.bgColor,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: card.color
                                        }}
                                    >
                                        {card.icon}
                                    </Box>
                                    {card.info && (
                                        <Box sx={{
                                            backgroundColor: card.bgColor,
                                            color: card.color,
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 1.5,
                                            fontSize: '0.7rem',
                                            fontWeight: 600,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.5
                                        }}>
                                            <TrendingUpIcon sx={{ fontSize: 12 }} />
                                            {card.info}
                                        </Box>
                                    )}
                                </Box>

                                {/* Count */}
                                <Typography
                                    variant="h3"
                                    sx={{
                                        fontWeight: 700,
                                        color: card.color,
                                        mb: 0.5,
                                        fontSize: '2.25rem',
                                        lineHeight: 1
                                    }}
                                >
                                    {card.count}
                                </Typography>

                                {/* Title */}
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        color: '#0B2D6B',
                                        mb: 0.5,
                                        fontSize: '1rem'
                                    }}
                                >
                                    {card.title}
                                </Typography>

                                {/* Subtitle */}
                                {/* <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#64748B',
                                        mb: card.progress ? 1.5 : 0,
                                        fontSize: '0.85rem'
                                    }}
                                >
                                    {card.subtitle}
                                </Typography> */}

                                {/* Progress Bar */}
                                {/* {card.progress && (
                                    <Box>
                                        <LinearProgress
                                            variant="determinate"
                                            value={card.progress > 100 ? 100 : card.progress}
                                            sx={{
                                                height: 6,
                                                borderRadius: 3,
                                                backgroundColor: card.bgColor,
                                                '& .MuiLinearProgress-bar': {
                                                    backgroundColor: card.color,
                                                    borderRadius: 3
                                                }
                                            }}
                                        />
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: '#64748B',
                                                mt: 0.5,
                                                display: 'block',
                                                fontSize: '0.75rem'
                                            }}
                                        >
                                            {card.progressLabel}
                                        </Typography>
                                    </Box>
                                )} */}
                            </Box>
                        </Grid>
                        );
                    })}
                </Grid>

                {/* Summary Section */}
                <Box sx={{ mt: 3 }}>
                    <Box sx={{
                        p: 3,
                        borderRadius: 3,
                        backdropFilter: 'blur(8px)',
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        border: '2px solid rgba(255,255,255,0.2)',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                        color: 'white'
                    }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, fontSize: '1.1rem' }}>
                            Keep Up the Great Work! 🎉
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.95, fontSize: '0.9rem', lineHeight: 1.6 }}>
                            You're making excellent progress on your wellness journey. Stay consistent with your activities and mood check-ins for better insights.
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default Insights
